import React from 'react'
import './Balloon.css'
import balloon from '../../img/ms-balloon.png'

const Balloon = (props) => {
  return (
    <section className="balloon-section">
      <div className="container-fluid" >

        <div className="balloon-figure" >
          <img src={balloon} className="balloon-img"  alt="balloon"/>
          <h2 className="text-uppercase balloon-heading">Time to Lift Mississippi</h2>
          <h1 className="text-uppercase balloon-heading">Out of Last Place</h1>
          <h3><i className="fa fa-chevron-down" aria-hidden="true"></i></h3>
        </div>

      </div>
    </section>
  );
}

export default Balloon;



/** WEBPACK FOOTER **
 ** ./src/components/home/Balloon.js
 **/